<app-vehicle-model-autocomplete [control]="control" [vehicleModelUuid]="initialModelUuid" [disable]="disabled" (vehicleModelSelected)="onVehicleSelect($event)"></app-vehicle-model-autocomplete>
